import { createContext, useContext } from 'react';

// The z-index of the drawer or modal a component renders inside, or null on
// the page itself. ThemedDrawer, DarkDrawer and ThemedModal provide it, and
// ThemedModal reads it so a modal opened from inside a drawer lands above that
// drawer instead of at its own default of 200, behind it. React context crosses
// portals, so this holds even though Mantine renders overlays at <body>. See
// #2384: the avatar and image crop modals opened hidden behind drawers, and on
// phones the page looked frozen.
export const OverlayLayerContext = createContext<number | null>(null);

export const useParentOverlayZIndex = (): number | null => useContext(OverlayLayerContext);

/** How far above its parent overlay a ThemedModal opens by default. */
export const OVERLAY_LAYER_STEP = 1000;
